import React from 'react'
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';

export default function CustomList({ bulletIcon, listText }) {
    let listItems = listText.map((text, i) => 
        <ListItem key={i}>
            <ListItemIcon>{bulletIcon}</ListItemIcon>
            <ListItemText
                primaryTypographyProps={{ variant: 'body1' }}
                primary={
                    <div style={{ marginLeft: '-16px' }}>
                        {text}
                    </div>
                }
            />
        </ListItem>)

    return (
        <List disablePadding={true} dense={true}>
            {listItems}
        </List>
    )
}